const initialState = {
  location_ids: [],
  name: "",
  description: "",
};

const segmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_LOCATION_SEGMENT":
      return {
        ...state,
        location_ids: action.locations,
      };
    case "SET_GEO_SEGMENT_NAME":
      return {
        ...state,
        name: action.name,
      };
    case "SET_GEO_SEGMENT_DESCRIPTION":
      return {
        ...state,
        description: action.description,
      };
    case "CLEAR_GEO_SEGMENT_FORM":
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};

export default segmentReducer;
